"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSession = exports.isDoiDSO = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _DomHelper = require("../DomHelper");
var _Router = require("../Router");
var _StringHelpers = _interopRequireDefault(require("../StringHelpers"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// const baseApiURLs = 'https://i-api.eon.de/grid/cscn-customer-srv';
var cscData = (0, _DomHelper.getIdDataset)('cscn-config', 'props');
var cscConfig = cscData ? JSON.parse((0, _StringHelpers.default)(cscData)) : null;
var mhaData = (0, _DomHelper.getIdDataset)('iconn-mhap-config', 'props');
var mhaConfig = mhaData ? JSON.parse((0, _StringHelpers.default)(mhaData)) : null;
var cicDomains = (0, _DomHelper.getIdDataset)('CSCN_MW_URL', 'cicMiddlewareDomains');
var domain = (0, _DomHelper.getIdDataset)('CSCN_MW_URL', 'middlewareDomain');
var isDoiDSO = exports.isDoiDSO = function isDoiDSO(DSO) {
  return DSO;
};
var getAppidFromParamIfPresent = function getAppidFromParamIfPresent() {
  var _getQParameterByName;
  return (_getQParameterByName = (0, _Router.getQParameterByName)('appid')) === null || _getQParameterByName === void 0 ? void 0 : _getQParameterByName.slice(3);
};
var possibleConfigs = {
  "app006": mhaConfig,
  "app0061": mhaConfig,
  "app0062": mhaConfig,
  "app004": cscConfig,
  "app0041": cscConfig,
  "app001": cscConfig,
  "app0011": cscConfig,
  "app010": mhaConfig,
  "app0101": mhaConfig,
  "app0102": mhaConfig,
  "app0103": mhaConfig
};
var appid = getAppidFromParamIfPresent();
var currentConfig = appid ? possibleConfigs["app".concat(appid)] : cscConfig;
var CONFIG = {
  CHANNEL_CONFIG: {
    anonymMR: 'ANONYMOUSMETERREADING',
    loggedInCsc: 'CSC'
  },
  AEM_CONFIG: _objectSpread(_objectSpread({
    cscConfigAdded: !!cscConfig
  }, currentConfig), {}, {
    isDkePage: (0, _DomHelper.getInputValueIfExists)('dke-page') === 'true',
    isAuthorMode: (0, _DomHelper.getInputValueIfExists)('author_mode') !== null,
    middlewareDomains: cicDomains ? _objectSpread(_objectSpread({}, JSON.parse(cicDomains)), {}, {
      csc: domain
    }) : {
      csc: domain || ""
    },
    siteVariable: cscConfig === null || cscConfig === void 0 ? void 0 : cscConfig.siteVariable
  })
};
// eslint-disable-next-line no-console
console.log("CURRENTCONF", appid, currentConfig);
var _default = exports.default = CONFIG;
var setSession = exports.setSession = function setSession() {
  _ciamAuthWebClientLib.SessionHandler.setConfig({
    loginPageExitUrl: CONFIG.AEM_CONFIG.SSO.ssoLogout,
    loginPageUrl: CONFIG.AEM_CONFIG.SSO.ssoLoginUrl,
    clientId: CONFIG.AEM_CONFIG.SSO.clientId,
    loginSuccessPath: CONFIG.AEM_CONFIG.SSO.loginSuccessPath,
    authorizationUrl: CONFIG.AEM_CONFIG.SSO.ssoExchangeUrl,
    refereshUrl: CONFIG.AEM_CONFIG.SSO.ssoExchangeUrl
  }, {
    post: function post(url, params) {
      return _axios.default.post(url, params);
    }
  });
};